
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../router/all_routes';
import AOS from 'aos';

const TermsConditions = () => {
  const routes = all_routes;

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div className="main-wrapper">
      {/* Breadcrumb Info */}
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">Termeni și Condiții</h2>
              <nav aria-label="breadcrumb" className="page-breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.home}>Acasă</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Termeni și Condiții
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {/* /Breadcrumb Info */}

      {/* Terms Content */}
      <section className="section-modern" style={{ padding: '60px 0' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div 
                className="terms-content" 
                style={{ background: '#fff', padding: '40px', borderRadius: '15px', boxShadow: '0 5px 20px rgba(0,0,0,0.05)' }}
                data-aos="fade-up"
              >
                 <div className="alert alert-warning mb-4">
                    <i className="fa-solid fa-triangle-exclamation me-2"></i>
                    <strong>Notă pentru Administrator:</strong> Vă rugăm să înlocuiți textele marcate cu [PARANTEZE] cu datele reale ale companiei dumneavoastră înainte de lansare. Acest document este un model standard și trebuie revizuit de un avocat.
                 </div>

                <div className="terms-header mb-5">
                  <h3 className="mb-3">1. Dispoziții Generale</h3>
                  <p>
                    Accesarea și utilizarea site-ului <strong>AD SHOWROOM</strong> (denumit în continuare "Site-ul") implică acceptarea expresă și integrală a acestor Termeni și Condiții. 
                  </p>
                  <p>
                    Site-ul este deținut și administrat de <strong>AD SHOWROOM S.R.L.</strong>, persoană juridică de naționalitate română, având sediul social în [ADRESA COMPLETA], înregistrată la Oficiul Registrului Comerțului sub nr. [J/XX/XXXX/AN], având Cod Unic de Înregistrare [CUI], denumită în continuare "Vânzătorul" sau "Compania".
                  </p>
                  <p>
                    <strong>Date de contact:</strong><br/>
                    Email: adcarshowroom@gmail.com<br/>
                    Telefon: +40 774 555 555
                  </p>
                </div>

                <div className="terms-text mb-5">
                  <h3 className="mb-3">2. Definiții</h3>
                  <ul className="list-unstyled ms-3">
                    <li className="mb-2"><strong>Utilizator:</strong> Orice persoană fizică sau juridică care accesează Site-ul.</li>
                    <li className="mb-2"><strong>Cumpărător/Client:</strong> Orice persoană fizică sau juridică ce plasează o comandă sau face o rezervare prin intermediul Site-ului.</li>
                    <li className="mb-2"><strong>Autovehicul/Bun:</strong> Produsul prezentat spre vânzare pe Site.</li>
                    <li className="mb-2"><strong>Comandă Specială ("Vreau mașină pe comandă"):</strong> Serviciul prin care Compania caută și importă un autovehicul specific la cererea Clientului.</li>
                  </ul>
                </div>

                <div className="terms-text mb-5">
                  <h3 className="mb-3">3. Oferta Comercială și Prețurile</h3>
                  <p>
                    Toate informațiile folosite pentru descrierea Bunurilor disponibile pe Site (imagini statice / dinamice / prezentări multimedia / etc.) nu reprezintă o obligație contractuală din partea Vânzătorului, acestea fiind utilizate exclusiv cu titlu de prezentare. Pot exista mici diferențe între imaginile de prezentare și produsul real (nuanță culoare, echipări minore).
                  </p>
                  <p>
                    Prețurile afișate pe Site sunt exprimate în <strong>Euro (EUR)</strong> și includ TVA conform legislației în vigoare, dacă nu este specificat altfel (ex: TVA deductibil). Plata se poate face în Lei (RON) la cursul de vânzare al băncii partenere a Vânzătorului din ziua facturării sau la cursul BNR + x%, conform contractului final.
                  </p>
                </div>

                <div className="terms-text mb-5">
                  <h3 className="mb-3">4. Procedura de "Mașină pe Comandă"</h3>
                  <p>
                    Pentru serviciul "Vreau mașină pe comandă", procedura este următoarea:
                  </p>
                  <ol>
                      <li>Clientul completează formularul de cerere de pe Site.</li>
                      <li>Consultantul AD SHOWROOM contactează Clientul pentru a stabili detaliile exacte și bugetul.</li>
                      <li>Se prezintă o ofertă concretă (autovehicule identificate la parteneri externi).</li>
                      <li>Pentru demararea achiziției, se semnează un <strong>Contract de Intermediere/Vânzare</strong> și se achită un <strong>avans</strong> (stabilit contractual, de regulă între 10% și 30%).</li>
                      <li>Termenul estimativ de livrare este de [10-21] zile lucrătoare, dar poate varia în funcție de logistică și procedurile de import.</li>
                  </ol>
                </div>

                <div className="terms-text mb-5">
                  <h3 className="mb-3">5. Garanția și Conformitatea (ANPC)</h3>
                  <p>
                    Conform <strong>OUG nr. 140/2021</strong> și legislației incidente privind vânzarea bunurilor:
                  </p>
                  <ul>
                      <li>Pentru autovehiculele noi, garanția legală de conformitate este de <strong>2 ani</strong>.</li>
                      <li>Pentru autovehiculele rulate (second-hand), garanția comercială oferită este de <strong>12 luni</strong> (sau limita de km specificată în contract/certificatul de garanție), acoperind părțile principale (motor, cutie de viteze), conform certificatului de garanție înmânat la livrare.</li>
                  </ul>
                  <p>
                    Garanția nu acoperă consumabilele (plăcuțe frână, ulei, filtre, anvelope etc.) sau defectele survenite în urma exploatării necorespunzătoare.
                  </p>
                </div>

                <div className="terms-text mb-5">
                  <h3 className="mb-3">6. Dreptul de Retragere (Pentru Persoane Fizice)</h3>
                  <p>
                    Dacă contractul s-a încheiat la distanță (fără prezența fizică simultană a părților), Consumatorul (persoană fizică) beneficiază de o perioadă de <strong>14 zile calendaristice</strong> pentru a se retrage din contract fără a fi nevoit să justifice decizia de retragere.
                  </p>
                  <p>
                    <strong>Excepție importantă:</strong> Conform art. 16 din OUG 34/2014, sunt exceptate de la dreptul de retragere produsele confecționate după specificațiile prezentate de consumator sau personalizate în mod clar (ex: Mașini aduse pe Comandă Specială strict configurate pentru client). În cazul autovehiculelor de pe stoc rezervate online, se aplică dreptul de retragere pentru avans, în condițiile legii.
                  </p>
                </div>

                <div className="terms-text mb-5">
                  <h3 className="mb-3">7. Soluționarea Litigiilor</h3>
                  <p>
                    Orice litigiu apărut între Utilizatori/Cumpărători și Vânzător va fi rezolvat pe cale amiabilă. În cazul în care nu s-a reușit stingerea conflictului pe cale amiabilă, competența revine instanțelor de judecată românești de la sediul Vânzătorului.
                  </p>
                  <p>
                   Consumatorii au la dispoziție și platforma online de soluționare a litigiilor (SOL) și pot depune plângeri la ANPC (Autoritatea Națională pentru Protecția Consumatorilor).
                  </p>
                </div>

                <div className="terms-footer mt-5 pt-4 border-top">
                   <div className="compliance-logos d-flex gap-3 mb-3">
                      <a href="https://anpc.ro/" target="_blank" className="btn btn-outline-secondary btn-sm">Website ANPC</a>
                      <a href="https://ec.europa.eu/consumers/odr" target="_blank" className="btn btn-outline-secondary btn-sm">Platforma SOL</a>
                   </div>
                  <p className="text-muted mb-0">
                    Ultima actualizare: 25 Ianuarie 2026
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* /Terms Content */}
    </div>
  );
};

export default TermsConditions;
